import React from 'react';
import { I18NContext } from '../context';

export function useI18N() {
  return React.useContext(I18NContext);
}
